import { useState } from "react";

export const usePagination = (startPage) => {
  const [page, setPage] = useState(startPage);

  return { page, setPage };
};

const DEFAULT_PAGINATION_PAGE_SIZE = 20;

export const usePaginationPageSize = (
  initialPageSize = DEFAULT_PAGINATION_PAGE_SIZE
) => {
  const [pageSize, setPageSize] = useState<number>(initialPageSize);

  return { pageSize, setPageSize };
};
